import { render, staticRenderFns } from "./FinanceAndDuban.vue?vue&type=template&id=b80a16f8&scoped=true"
import script from "./FinanceAndDuban.vue?vue&type=script&lang=js"
export * from "./FinanceAndDuban.vue?vue&type=script&lang=js"
import style0 from "./FinanceAndDuban.vue?vue&type=style&index=0&id=b80a16f8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80a16f8",
  null
  
)

export default component.exports